<template>
	<a class="nav-item nav-link" :class="{'active': isActive}" data-toggle="tab" :href="`#${id}`" role="tab" aria-controls="nav-all" aria-selected="true">{{ title }} ({{ count }})</a>
</template>

<script>
export default {
	name: 'ButtonTab',
	props: ['id', 'title', 'count', 'isActive']
}
</script>